import React, { useCallback, useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from '@/common/dependencies';
import DownloadModal from '@/components/modal/wcp-download';
import { isFEPlanStepId, McpFilesConfig } from '@shared/constants/mcp';
import client from '@/store/client';
import { SVGPureIcon } from '@/ui';
import wcpDownloadStore from '@/components/modal/wcp-download/store';
import Tooltip from "@/ui/tooltip";
import ColorContainer from '@/components/color-container';
import connectionLineStore from '@/components/chat-history/connection-line/store';
import EE from '@/common/event';
import fullScreenModalStore from '@/components/full-screen-modal/store';

const MAX_SHOW_COUNT = HelperCore.isPhone() ? 500 : 5;

const McpToolsFiles = observer((props) => {
  const {
    className = '',
    mcpStore,
    event,
    attachments,
    messageItem,
  } = props;

  const [toggle, setToggle] = useState(true)

  if(!attachments?.length){
    return null;
  }

  const handleClick = (item, config, toggle = false) => {
    try{
      mcpStore.chatStore.log({
        action : "click",
        set : "agent_file",
        url : item.url || "",
      });
    } catch(e){}

    if(!config.supportPreview){
      if(item.url){
        // client.openPage(item.url);
        mcpStore.downloadFile(item)
      }
      return;
    }

    // 打开全屏预览
    const attachmentNode = mcpStore.toolsAttachmentsNodes.find(node => item.planStepId === node.planStepId);
    if (attachmentNode) {
      fullScreenModalStore.updateData(attachmentNode, mcpStore.chatStore.chatId);
      // console.log(item.planStepId, attachmentNode, mcpStore.chatStore.chatId);
    }

    // 不再有“退出预览”
    // 附件节点点击时，不再连右侧卡片 6.20
    // mcpStore.setPanelMessageId(messageItem.msg_id);
    // mcpStore.setCurrentPanelId(item.planStepId, true);
    // const id = `${messageItem?.msg_id || ''}_${item?.planStepId || ''}`;
    // connectionLineStore.updatePoint(id);
    // EE.emit("vnc-cards-scroll");
    return;

    // 附件都要求用 FileViewer 展示
    if (toggle) {
      if (mcpStore.currentFileNode?.url == item.url ) {
        mcpStore.setCurrentFileNode(null);
      } else {
        mcpStore.setCurrentFileNode(item);
      }
      return
    }
    mcpStore.setCurrentFileNode(item);
  }

  const onToggle = useCallback(() => {
    setToggle(!toggle)
  }, [toggle])

  // const handlePosition = (item) => {
  //   // 总结生成的文件，一般是 pdf
  //   if(!item.planStepId){
  //     if(item.contentType == "pdf"){
  //       mcpStore.setCurrentFileNode(item);
  //     }
  //     else {
  //       console.error(`tools click error:`, item);
  //     }
  //     return;
  //   }

  //   mcpStore.setPanelMessageId(messageItem.msg_id);
  //   mcpStore.setCurrentPanelId(item.planStepId);
  //   mcpStore.setShowRightPanel(true);
  // }

  

  const renderBtn = (item, config) => {
    let node
    if (config.supportPreview) {
      node = (
        <div onClick={(e) => {
          // e.stopPropagation()
          // mcpStore.setCurrentFileNode(item);
        }}  className='w-88px h-32px bg-[#000] hover:bg-[#333] rounded-8px text-center leading-32px  text-[#fff] text-14px'>全屏查看</div>
      )
    } else {
      node = (
        <div onClick={(e) => {
          e.stopPropagation()
          handleClick(item, config);
        }}  className='w-88px h-32px box-border box-border border-1px hover:bg-[rgba(0,0,0,0.03)] border-black rounded-8px text-center leading-32px text-[#000] text-14px'>下载文档</div>
      )
    }
    return node
  }

  const allAttachmentsWithoutHtml = attachments;
  
  const summaryFiles = allAttachmentsWithoutHtml.filter((item) => !item.planStepId || isFEPlanStepId(item.planStepId))
  // 过程中产生的文件，不再显示
  const planStepFiles = [] || allAttachmentsWithoutHtml.filter((item) => item.planStepId)
 
  const batchDownload = useCallback(() => {
    if (wcpDownloadStore.loading) {
      return
    }
    wcpDownloadStore.agentBatchDownload(
      {
        cid: mcpStore.chatStore.chatId,
        files: planStepFiles
          .map(item => ({
            url: item.url,
            name: item.title,
          }))
          .filter(item => !!item.url),
      },
      download_url => {
        mcpStore.downloadFile({
          url: download_url,
          title: 'download'
        });
      }
    );
  }, [planStepFiles]);

  return (
    <div 
      className={`flex w-full mcp-attachment flex-col ${className}`} 
      style={{
        gap : 'var(--nw-mcp-card-sep)',
      }}
      data-id={event?.planStepId}>
      {
        summaryFiles?.map((item, index) => {
          const config = McpFilesConfig[item.contentType] || McpFilesConfig.default;
          const icon = config.getIcon ? config.getIcon(item) : config.icon;
          const isActive = item.planStepId == mcpStore.currentPanelId;
          const id = `${messageItem?.msg_id || ''}_${item?.planStepId || ''}`;
          return (
            <ColorContainer
              key={`${index}_${id}`}
              active={isActive}
              >
              <div 
                className={`p-12px ui-tools-box relative flex items-center cursor-pointer rounded-12px border-1px  ${mcpStore.currentFileNode?.url == item.url ? 'border-[#000]' : 'border-[rgba(0,0,0,0.1)]'} bg-white hover:border-black hover:border-opacity-30`}
                data-id={id || "mcp-final-file"}
                data-msg={messageItem.msg_id}
                onClick={
                  () => {
                    handleClick(item, config, true);
                  }  
                }
              >
                <img data-type={item.contentType} src={icon} className="size-32px rounded-8px  mr-8px" />
                <div className="mr-16px w-0 flex-grow">
                  <div className="text-14px leading-20px truncate font-bold h-20px">
                    {item.title}
                  </div>
                  {
                    item.file_size
                    ? (
                      <div className="text-12px leading-17px truncate text-black text-opacity-50 h-17px">
                        {
                          item.file_size > 0
                          ? HelperCore.getFixedTextSize(item.file_size, 2)
                          : null
                        }
                      </div>
                    )
                    : null
                  }
                </div>
                {
                  renderBtn(item, config)
                }
                
              </div>
            </ColorContainer>
          )
        })
      }
      {
        planStepFiles?.length ? 
          <div className='w-full px-8px py-16px ui-tools-box border-1px rounded-12px border-[rgba(0,0,0,0.1)] select-none bg-white'>
          <div className='flex px-8px items-center'>
            <div className='flex-1 text-16px font-semibold'>此任务所有文件</div>
            <div className='flex'>
              
              <Tooltip title="批量下载">
                <span className='mr-12px size-28px hover:bg-[rgba(0,0,0,0.06)] rounded-8px'>
                  <SVGPureIcon onClick={batchDownload} name='ic-batchdown' className='text-[#000] cursor-pointer ' size={28} />
                </span>
              </Tooltip>
              <Tooltip title={toggle ? '展开' : '收起'}>
                <span className='size-28px hover:bg-[rgba(0,0,0,0.06)] rounded-8px'>
                  <SVGPureIcon name='arrow' style={{
                    transform: `${toggle ? 'rotate(180deg)' : 'rotate(0deg)'}`
                  }} onClick={onToggle}  className='cursor-pointer rotate-180' size={28}></SVGPureIcon>
                </span>
              </Tooltip>
              
            </div>
          </div>
          <div className={`${toggle ? 'hidden' : 'block'} flex gap-4px flex-col mt-10px`}>
            {
              planStepFiles.map((item, index) => {
                const config = McpFilesConfig[item.contentType] || McpFilesConfig.default;
                const icon = config.getIcon ? config.getIcon(item) : config.icon;
                const id = `${messageItem?.msg_id || ''}_${item?.planStepId || ''}`;
                return (
                  <div 
                    className='flex cursor-pointer group h-36px items-center  px-8px mcp-attachment rounded-8px hover:bg-[rgba(0,0,0,0.03)]'
                    key={`${index}_${id}`}
                    data-id={id || "mcp-final-file"}
                    data-msg={messageItem.msg_id}
                    onClick={
                      () => {
                        handleClick(item, config);
                      }  
                    }
                  >
                    <img data-type={item.contentType} src={icon} className="size-20px rounded-100px mr-6px" />
                    <div className='text-14px flex-1 text-[#000] truncate'> {item.title}</div>
                    <SVGPureIcon onClick={(e) => {
                      e.stopPropagation()
                      mcpStore.downloadFile(item)
                      // downloadFile(item)
                    }} className='hidden  !group-hover:block rounded-8px  hover:bg-[rgba(0,0,0,0.06)]' name='agent_download' size={28} />
                  </div>
                )
              })
            }
          </div>
        </div> : null
      }
     
      {/* {
        allAttachmentsWithoutHtml.slice(0, MAX_SHOW_COUNT).map((item, index) => {
          const config = McpFilesConfig[item.contentType] || McpFilesConfig.default;
          const icon = config.getIcon ? config.getIcon(item) : config.icon;

          return (
            <div 
              key={`${index}_${item.planStepId}`}
              data-id={item.planStepId || "mcp-final-file"}
              data-msg={messageItem.msg_id}
              className="mcp-attachment w-280px h-61px mr-16px mt-16px bg-white border-1px border-black rounded-12px border-opacity-10 flex items-center cursor-pointer hover:bg-black hover:bg-opacity-3"
              onClick={
                () => {
                  handleClick(item, config);
                }  
              }
              >
              <img data-type={item.contentType} src={icon} className="size-32px rounded-8px ml-12px mr-8px" />
              <div className="mr-16px w-0 flex-grow">
                <div className="text-14px leading-20px truncate font-bold h-20px">
                  {item.title}
                </div>
                {
                  item.file_size
                  ? (
                    <div className="text-12px leading-17px truncate text-black text-opacity-50 h-17px">
                      {
                        item.file_size > 0
                        ? HelperCore.getFixedTextSize(item.file_size, 2)
                        : null
                      }
                    </div>
                  )
                  : null
                }
              </div>
            </div>
          )
        })
      }

      <div 
        key="more"
        className={`mcp-attachment w-280px h-61px mr-16px mt-16px bg-white border-1px border-black rounded-12px border-opacity-10 flex items-center cursor-pointer hover:bg-black hover:bg-opacity-3 ${allAttachmentsWithoutHtml.length > MAX_SHOW_COUNT ? '' : 'hidden'}`}
        onClick={
          () => {
            DownloadModal.show({
              fileList : attachments,
              chatId : mcpStore.chatStore.chatId,
              mcpStore,
              handleAction : (type, attachment) => {
                const config = McpFilesConfig[attachment.contentType] || McpFilesConfig.default;
                switch(type){
                  // 预览
                  case "view":{
                    handleClick(attachment, config);
                    break;
                  }
                  // 定位
                  case "position":{
                    handlePosition(attachment);
                    const {
                      planStepId,
                    } = attachment;
                    const messageId = messageItem.msg_id;
                    setTimeout(() => {
                      try{
                        $(`[data-id='${messageId}'] [data-id='${planStepId || "mcp-final-file"}']`)[0].scrollIntoView({ block: 'center' });
                      } catch(e){}
                    }, 50);
                    break;
                  }
                }
              },
            });
          }
        }
        >
        <img src="https://p1.ssl.qhimg.com/d/inn/3f9a5122429e/mcp_files_more.png" className="size-32px rounded-8px ml-12px mr-8px" />
        <div className="mr-16px w-0 flex-grow">
          <div className="text-14px leading-20px truncate font-bold h-20px">
            查看此任务的所有文件
          </div>
          <div className="text-12px leading-17px truncate text-black text-opacity-50 h-17px">
            共{attachments.length}个
          </div>
        </div>
      </div> */}
    </div>
  )
});
export default McpToolsFiles;